export default "__VITE_ASSET__kxMqW0Cp__"